import { render } from "./t-button.vue?vue&type=template&id=92f30d62&scoped=true"
import script from "./t-button.vue?vue&type=script&lang=js"
export * from "./t-button.vue?vue&type=script&lang=js"

import "./t-button.vue?vue&type=style&index=0&id=92f30d62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92f30d62"]])

export default __exports__